// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.form__main {
  margin: 2% auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.form__main .main_label {
  font-weight: 800;
  font-size: 1.5rem;
  margin: auto;
}
.form__main .main_label span {
  color: #bf1a1a;
}
@media (max-width: 690px) {
  .form__main .main_label {
    text-align: center;
  }
}
.form__main select {
  margin: 1% 0;
  border: 1px solid #1d1d1d;
  border-radius: 0.5rem;
  width: 8%;
  background-color: transparent;
  color: #1d1d1d;
}
.form__main .site_select {
  margin: 1% auto;
}
.form__main h1 {
  margin: 1% auto;
  font-size: 2.25rem;
}
.form__main .interview_btn {
  display: inline-block;
  padding: 0.9rem 1.8rem;
  font-size: 16px;
  font-weight: 700;
  margin: 1% auto;
  color: #1d1d1d;
  border: 3px solid #bf1a1a;
  cursor: pointer;
  position: relative;
  background-color: transparent;
  text-decoration: none;
  overflow: hidden;
  z-index: 1;
  font-family: inherit;
}
.form__main .interview_btn:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #bf1a1a;
  transform: translateX(-100%);
  transition: all 0.3s;
  z-index: -1;
}
.form__main .interview_btn:hover::before {
  transform: translateX(0);
}
.form__main .form {
  width: 80%;
  margin: 2% auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.form__main .form select,
.form__main .form input {
  margin-bottom: 1%;
  border: 1px solid #1d1d1d;
  border-radius: 0.5rem;
  background-color: transparent;
  color: #1d1d1d;
}
.form__main .form label {
  font-weight: 600;
}
.form__main .form label span {
  color: #bf1a1a;
}
.form__main .form #first_day_alert,
.form__main .form #last_day_alert {
  display: none;
  color: #bf1a1a;
  font-weight: 800;
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
.form__main .form #ho_btn,
.form__main .form #rtms_btn,
.form__main .form #site_btn {
  margin: 2% 0;
}
.form__main .interview_form {
  width: 70%;
  margin: 1% auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.form__main .interview_form select,
.form__main .interview_form input {
  margin-bottom: 1%;
  border: 1px solid #1d1d1d;
  border-radius: 0.5rem;
  width: 30%;
  background-color: transparent;
  color: #1d1d1d;
}
.form__main .interview_form label {
  font-weight: 600;
}
.form__main .interview_form label span {
  color: #bf1a1a;
}
.form__main .interview_form .form_tips {
  font-style: oblique;
  color: #ff8808;
  margin: 1% 0 0 0;
}
.form__main .save_btn_row {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 40%;
  margin: 2% auto;
}
@media (max-width: 690px) {
  .form__main .save_btn_row {
    width: 80vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .form__main .save_btn_row:last-child {
    margin-top: 20%;
  }
}
@media (max-width: 690px) {
  .form__main .title {
    text-align: center;
  }
  .form__main .main_label {
    font-size: 1.2rem;
  }
  .form__main select {
    height: 1.3rem;
  }
  .form__main select,
  .form__main input,
  .form__main textarea {
    width: 70%;
  }
  .form__main #interview_btn {
    margin-top: 20px;
    width: 40%;
  }
  .form__main .form input {
    width: 30%;
    height: 1.2rem;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .form__main select {
    width: 18%;
  }
  .form__main .form select,
  .form__main .form input {
    width: 18%;
  }
}
@media (min-width: 851px) and (max-width: 1300px) {
  .form__main select {
    width: 15%;
  }
  .form__main .form select,
  .form__main .form input {
    width: 15%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/form.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI;IAEI,kCAAA;EAFN;EAKE;IAEI,iCAAA;EAJN;EAOE;IAGI,kCAAA;EAPN;EAUE;IAEI,iCAAA;EATN;AACF;AAYA;EACI,eAAA;ECOA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EDRA,WAAA;AAPJ;AAQI;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;AANR;AAOQ;EACI,cClCJ;AD6BR;AAOQ;EAPJ;IAQQ,kBAAA;EAJV;AACF;AAOI;EACI,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;EACA,6BAAA;EACA,cC9CE;ADyCV;AAOI;EACI,eAAA;AALR;AAOI;EACI,eAAA;EACA,kBAAA;AALR;AAOI;EACI,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cC7DE;ED8DF,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;AALR;AAMQ;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBC9EJ;ED+EI,4BAAA;EACA,oBAAA;EACA,WAAA;AAJZ;AAMQ;EACI,wBAAA;AAJZ;AAQI;EACI,UAAA;EACA,eAAA;ECzDJ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ADoDJ;AAIQ;;EAEI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,cCjGF;AD+FV;AAIQ;EACI,gBAAA;AAFZ;AAGY;EACI,cCvGR;ADsGR;AAIQ;;EAEI,aAAA;EACA,cC7GJ;ED8GI,gBAAA;EACA,gEAAA;AAFZ;AAIQ;;;EAGI,YAAA;AAFZ;AAMI;EACI,UAAA;EACA,eAAA;EChGJ,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AD6FJ;AAEQ;;EAEI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EACA,6BAAA;EACA,cClIF;ADkIV;AAEQ;EACI,gBAAA;AAAZ;AACY;EACI,cCxIR;ADyIR;AAEQ;EACI,mBAAA;EACA,cC3IF;ED4IE,gBAAA;AAAZ;AAGI;ECpFA,aAAA;EACA,mBAAA;EACA,6BAAA;EDoFI,UAAA;EACA,eAAA;AACR;AAAQ;EAJJ;IAKQ,WAAA;ICrHR,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;EDyHF;EALU;IACI,eAAA;EAOd;AACF;AAHI;EACI;IACI,kBAAA;EAKV;EAHM;IACI,iBAAA;EAKV;EAFM;IACI,cAAA;EAIV;EADM;;;IAGI,UAAA;EAGV;EAAM;IACI,gBAAA;IACA,UAAA;EAEV;EACU;IACI,UAAA;IACA,cAAA;EACd;AACF;AAEI;EACI;IACI,UAAA;EAAV;EAGU;;IAEI,UAAA;EADd;AACF;AAII;EACI;IACI,UAAA;EAFV;EAKU;;IAEI,UAAA;EAHd;AACF","sourcesContent":["@import \"./variables.scss\";\n\n@keyframes shake {\n    10%,\n    90% {\n        transform: translate3d(-1px, 0, 0);\n    }\n\n    20%,\n    80% {\n        transform: translate3d(2px, 0, 0);\n    }\n\n    30%,\n    50%,\n    70% {\n        transform: translate3d(-4px, 0, 0);\n    }\n\n    40%,\n    60% {\n        transform: translate3d(4px, 0, 0);\n    }\n}\n\n.form__main {\n    margin: 2% auto;\n    @include columnStartCenter;\n    width: 100%;\n    .main_label {\n        font-weight: 800;\n        font-size: 1.5rem;\n        margin: auto;\n        span {\n            color: $rtRed;\n        }\n        @media (max-width: $mobile) {\n            text-align: center;\n        }\n    }\n\n    select {\n        margin: 1% 0;\n        border: 1px solid $rtBlack;\n        border-radius: 0.5rem;\n        width: 8%;\n        background-color: transparent;\n        color: $rtBlack;\n    }\n    .site_select {\n        margin: 1% auto;\n    }\n    h1 {\n        margin: 1% auto;\n        font-size: 2.25rem;\n    }\n    .interview_btn {\n        display: inline-block;\n        padding: 0.9rem 1.8rem;\n        font-size: 16px;\n        font-weight: 700;\n        margin: 1% auto;\n        color: $rtBlack;\n        border: 3px solid $rtRed;\n        cursor: pointer;\n        position: relative;\n        background-color: transparent;\n        text-decoration: none;\n        overflow: hidden;\n        z-index: 1;\n        font-family: inherit;\n        &:before {\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 0;\n            width: 100%;\n            height: 100%;\n            background-color: $rtRed;\n            transform: translateX(-100%);\n            transition: all 0.3s;\n            z-index: -1;\n        }\n        &:hover::before {\n            transform: translateX(0);\n        }\n    }\n\n    .form {\n        width: 80%;\n        margin: 2% auto;\n        @include columnStartCenter;\n        select,\n        input {\n            margin-bottom: 1%;\n            border: 1px solid $rtBlack;\n            border-radius: 0.5rem;\n            background-color: transparent;\n            color: $rtBlack;\n        }\n        label {\n            font-weight: 600;\n            span {\n                color: $rtRed;\n            }\n        }\n        #first_day_alert,\n        #last_day_alert {\n            display: none;\n            color: $rtRed;\n            font-weight: 800;\n            animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n        }\n        #ho_btn,\n        #rtms_btn,\n        #site_btn {\n            margin: 2% 0;\n        }\n    }\n\n    .interview_form {\n        width: 70%;\n        margin: 1% auto;\n        @include columnStart;\n        select,\n        input {\n            margin-bottom: 1%;\n            border: 1px solid $rtBlack;\n            border-radius: 0.5rem;\n            width: 30%;\n            background-color: transparent;\n            color: $rtBlack;\n        }\n        label {\n            font-weight: 600;\n            span {\n                color: $rtRed;\n            }\n        }\n        .form_tips {\n            font-style: oblique;\n            color: $warning;\n            margin: 1% 0 0 0;\n        }\n    }\n    .save_btn_row {\n        @include rowEven;\n        width: 40%;\n        margin: 2% auto;\n        @media (max-width: $mobile) {\n            width: 80vw;\n            @include columnStartCenter;\n            &:last-child {\n                margin-top: 20%;\n            }\n        }\n    }\n\n    @media (max-width: $mobile) {\n        .title {\n            text-align: center;\n        }\n        .main_label {\n            font-size: 1.2rem;\n        }\n\n        select {\n            height: 1.3rem;\n        }\n\n        select,\n        input,\n        textarea {\n            width: 70%;\n        }\n\n        #interview_btn {\n            margin-top: 20px;\n            width: 40%;\n        }\n        .form {\n            input {\n                width: 30%;\n                height: 1.2rem;\n            }\n        }\n    }\n    @media (min-width: $tabletMin) and (max-width: $tabletMax) {\n        select {\n            width: 18%;\n        }\n        .form {\n            select,\n            input {\n                width: 18%;\n            }\n        }\n    }\n    @media (min-width: $landsTabletMin) and (max-width: $landsTabletMax) {\n        select {\n            width: 15%;\n        }\n        .form {\n            select,\n            input {\n                width: 15%;\n            }\n        }\n    }\n}\n","$rtRed: #bf1a1a;\n$rtBlack: #1d1d1d;\n$warning: #ff8808;\n$success: #00a74f;\n\n//Brand Colours\n$hr_dark_blue: #012748;\n$hr_blue: #0f4e6f;\n$hr_gold: #b66d2d;\n$hr_orange: #fe9816;\n$hr_yellow: #fede8c;\n\n//mobile breaks\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnEnd {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-end;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin shadow {\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
